var FilterRule = /** @class */ (function () {
    function FilterRule(param) {
        this.includeInFilterCount = true;
        this.includeInReset = true;
        this.param = param;
        this.val = null;
    }
    Object.defineProperty(FilterRule.prototype, "parameter", {
        get: function () {
            return this.param;
        },
        set: function (param) {
            this.param = param;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FilterRule.prototype, "value", {
        get: function () {
            return this.val;
        },
        set: function (val) {
            this.val = val;
        },
        enumerable: false,
        configurable: true
    });
    FilterRule.prototype.isActive = function () {
        return this.param != null && this.val != null;
    };
    FilterRule.prototype.apply = function (object) {
        if (!object) {
            return false;
        }
    };
    return FilterRule;
}());
export default FilterRule;
